import Vue from 'vue'
import Router from 'vue-router'
import home from '@/components/home'
import product from '@/components/product'
import news from '@/components/news'
import newsDetail from '@/components/newsDetail'
import price from '@/components/price'
import contact from '@/components/contact'
import numberGrow from '@/components/numberGrow'
import assetInfo from '@/components/assetInfo'


Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: home
    },{
      path: '/numberGrow',
      name: 'numberGrow',
      component: numberGrow
    },{
      path: '/product',
      name: 'product',
      component: product
    },{
      path: '/news',
      name: 'news',
      component: news
    },{
      path: '/newsDetail',
      name: 'newsDetail',
      component: newsDetail
    },{
      path: '/price',
      name: 'price',
      component: price
    },{
      path: '/contact',
      name: 'contact',
      component: contact
    },{
      path: '/assetInfo',
      name: 'assetInfo',
      component: assetInfo
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js